import { get } from '../index';

export const getStatuses = (company) => {
  return get(`/statuses/?company=${company}`);
};
